module.exports = __webpack_public_path__ + "img/0-sm.f16ec163.jpg";